(() => {
  const params = new URLSearchParams(window.location.search);
  const heroCandidate = params.get('t5a4_hero');
  const sddColumns = params.get('t5a4_sdd_cols');
  const gluelessColumns = params.get('t5a4_glueless_cols');

  if (['4', '5'].includes(sddColumns)) document.documentElement.dataset.iyrsSddColumns = sddColumns;
  if (['4', '5'].includes(gluelessColumns)) document.documentElement.dataset.iyrsGluelessColumns = gluelessColumns;

  if (['a', 'b', 'c'].includes(heroCandidate)) {
    const hero = document.querySelector('[data-iyrs-t5-hero]');
    const image = hero?.querySelector('[data-iyrs-t5-hero-image]');
    const source = hero?.querySelector('[data-iyrs-t5-hero-source]');
    const candidateSrc = image?.dataset[`${heroCandidate}Src`];
    if (hero && image && candidateSrc) {
      hero.dataset.iyrsHeroCandidate = heroCandidate;
      image.src = candidateSrc;
      image.alt = image.dataset[`${heroCandidate}Alt`] || image.alt;
      const mobileSrc = source?.dataset[`${heroCandidate}Src`];
      if (source && mobileSrc) source.srcset = mobileSrc;
    }
  }

  class IyrsT5Slider {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-iyrs-t5-track]');
      this.slides = [...root.querySelectorAll('[data-iyrs-t5-slide]')];
      this.dots = [...root.querySelectorAll('[data-iyrs-t5-dot]')];
      this.index = 0;
      this.timer = null;
      if (!this.track || this.slides.length < 2) return;
      root.querySelector('[data-iyrs-t5-prev]')?.addEventListener('click', () => this.show(this.index - 1, true));
      root.querySelector('[data-iyrs-t5-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true)));
      root.addEventListener('mouseenter', () => this.stop());
      root.addEventListener('mouseleave', () => this.start());
      root.addEventListener('focusin', () => this.stop());
      root.addEventListener('focusout', () => this.start());
      this.show(0, false);
      this.start();
    }

    show(next, userInitiated) {
      this.index = (next + this.slides.length) % this.slides.length;
      this.track.style.transform = `translate3d(-${this.index * 100}%, 0, 0)`;
      this.dots.forEach((dot, index) => dot.toggleAttribute('aria-current', index === this.index));
      if (userInitiated) this.start();
    }

    start() {
      this.stop();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = window.setInterval(() => this.show(this.index + 1, false), 7000);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  document.querySelectorAll('[data-iyrs-t5-slider]').forEach((root) => new IyrsT5Slider(root));
})();
